import script from "./ContactSupportDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSupportDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ContactSupportDrawer.vue?vue&type=style&index=0&id=88bdd5fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88bdd5fc"]])

export default __exports__